import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { UpdateCreditHistoryModalData, UpdateTotalCreditAmount } from "../Store";
import { changeCreditIsActive } from "../Store/Thunk";
import {
  AdminListCard,
  AdminListMain,
  AdminActions,
  AdminButton,
  AdminSwitch,
} from "../../../SharedComponents/ListView";

export default function AssessmentList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const creditsList = useSelector((state) => state.credits.creditsList);

  const HandleShowHistoryButton = (credit) => {
    dispatch(UpdateTotalCreditAmount(credit.creditAmount));
    dispatch(
      UpdateCreditHistoryModalData({
        creditId: credit.id,
        assessmentName: credit.assessmentName,
        isShown: true,
      })
    );
  };

  return (
    creditsList &&
    creditsList.map((credit, i) => (
      <AdminListCard key={"credit" + i}>
        <AdminListMain>
          <span className="admin-list-id">{credit.id}</span>
          <span className="admin-list-title">{credit.assessmentName}</span>
        </AdminListMain>
        <AdminActions>
          <AdminSwitch
            checked={credit.isActive}
            onChange={() =>
              dispatch(changeCreditIsActive({ creditId: credit.id, isActive: !credit.isActive }))
            }
          />
          <AdminButton onClick={() => HandleShowHistoryButton(credit)}>{t("historyButtonLabel")}</AdminButton>
          <span className="admin-credit-amount">{credit.creditAmount}</span>
        </AdminActions>
      </AdminListCard>
    ))
  );
}
